export default {
  root: {
    class: [
      // Flex
      'flex items-center justify-center',

      // Space
      'p-3',

      // Size
      'min-w-12',

      // Color
      'bg-surface-50',
      'text-surface-600',
    ],
  },
};
